import React from 'react';
import { Spin, Tooltip } from 'antd';
import clsx from 'clsx';

import { ClImage } from '../ClImage';

export interface AvatarProps {
  name?: string;
  image?: string | null;
  width?: number;
  height?: number;
  loading?: boolean;
  round?: boolean;
}

export const Avatar: React.FC<AvatarProps> = ({
  name,
  image,
  width = 16,
  height = width,
  loading = false,
  round = false,
}) => (
  <div style={{ display: 'inline-block' }}>
    <Spin spinning={loading}>
      <Tooltip title={name || undefined}>
        <ClImage
          className={clsx('b-imgGallery__img', {
            '-style_round': round,
          })}
          publicId={image || 'avatar.jpg'}
          transformation={{
            height: String(height),
            width: String(width),
            dpr: '2.0',
            crop: 'fill',
            default_image: 'avatar.jpg',
          }}
          height={height}
          width={width}
        />
      </Tooltip>
    </Spin>
  </div>
);
